import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { useIntl, useSelector, statusSuccess, statusFailed, statusLoading } from '@grandvisionhq/state';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getPrescription, getPrescriptionType } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import PrescriptionSummary from './PrescriptionSummary.js';

const PrescriptionSummaryContainer = ()=>{
    const { hasLabel , getLabel  } = useIntl();
    const prescription = useSelector(getPrescription);
    const prescriptionType = useSelector(getPrescriptionType);
    const labels = React.useMemo(()=>{
        if (!statusSuccess(prescription)) {
            return {};
        }
        const { parameters  } = prescription.result;
        const paramLabels = parameters.reduce((acc, { name  })=>swcHelpers.objectSpread({}, acc, {
                [name]: getLabel(`products.glasses.prescription.${name}`)
            })
        , {});
        return swcHelpers.objectSpread({}, paramLabels, {
            rightEye: hasLabel('products.glasses.rightEye') ? getLabel('products.glasses.rightEye') : undefined,
            leftEye: hasLabel('products.glasses.leftEye') ? getLabel('products.glasses.leftEye') : undefined,
            prescriptionTitle: hasLabel('products.glasses.configurator.footer.prescription.title') ? getLabel('products.glasses.configurator.footer.prescription.title') : undefined,
            existingCustomer: hasLabel('products.glasses.configurator.footer.existingCustomer') ? getLabel('products.glasses.configurator.footer.existingCustomer') : undefined,
            emailPrescription: hasLabel('products.glasses.configurator.footer.emailPrescription') ? getLabel('products.glasses.configurator.footer.emailPrescription') : undefined
        });
    }, [
        hasLabel,
        getLabel,
        prescription
    ]);
    if (statusFailed(prescription)) {
        return /*#__PURE__*/ React.createElement("p", null, getLabel('products.glasses.prescription.loadingFailed'));
    }
    if (statusLoading(prescription)) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (!statusSuccess(prescription)) {
        return null;
    }
    const { right , left , parameters: parameters1 , uploadReferences  } = prescription.result;
    return /*#__PURE__*/ React.createElement(PrescriptionSummary, {
        prescriptionType: prescriptionType,
        parameters: parameters1,
        right: right,
        left: left,
        labels: labels,
        uploadReferences: uploadReferences
    });
};

export { PrescriptionSummaryContainer as default };
//# sourceMappingURL=PrescriptionSummaryContainer.js.map
